import { Dispatch, createSlice } from "@reduxjs/toolkit";
import { TRequestStatus } from "@models/msc.model";
import proofNotificationsService from "@/services/proof.notifications.service";
import { RootState } from "..";
import { TProofNotification } from "@/models/proof.notifications.model";

type ProofNotificationsState = {
  initialized: boolean;
  status: TRequestStatus;
  proofNotifications: TProofNotification[];
};

//-----THUNK FUNCTIONS-----

const initialState: ProofNotificationsState = {
  initialized: false,
  status: "IDLE",
  proofNotifications: [],
};

const proofNotificationsSlice = createSlice({
  name: "proofNotifications",
  initialState,
  reducers: {
    startLoading(state) {
      state.status = "PENDING";
    },
    rollback(state, actions) {
      state.status = "IDLE";
      state.proofNotifications = actions.payload;
    },
    gotProofNotifications(state, action) {
      state.proofNotifications = action.payload;
      state.status = "IDLE";
      state.initialized = true;
    },
    proofNotificationCreated(state, action) {
      state.proofNotifications = [action.payload, ...state.proofNotifications];
    },
    proofNotificationUpdated(state, action) {
      state.proofNotifications = state.proofNotifications.map((t) => (t.id === action.payload.id ? action.payload : t));
    },
    proofNotificationRemoved(state, action) {
      state.proofNotifications = state.proofNotifications.filter((t) => t.id !== action.payload);
    },
  },
});

// ----------------------------

export const getAllProofNotifications = () => async (dispatch: Dispatch, getState: () => RootState) => {
  const {
    proofNotifications: { proofNotifications, initialized },
  } = getState();

  if (initialized) return proofNotifications;

  dispatch(proofNotificationsSlice.actions.startLoading());
  const response = await proofNotificationsService.getAll();
  dispatch(proofNotificationsSlice.actions.gotProofNotifications(response));
  return response;
};

// ----------------------------
export const createProofNotification = (data: TProofNotification) => async (dispatch: Dispatch) => {
  const response = await proofNotificationsService.save(data);
  dispatch(proofNotificationsSlice.actions.proofNotificationCreated(response));
  return response;
};

// ----------------------------
export const updateProofNotification =
  (data: Partial<TProofNotification> & { id: number }) => async (dispatch: Dispatch) => {
    const { id, ...rest } = data;
    const response = await proofNotificationsService.updateById(id, rest);
    dispatch(proofNotificationsSlice.actions.proofNotificationUpdated(response));
    return response;
  };

// ----------------------------

export const deleteProofNotification = (id: number) => async (dispatch: Dispatch, getState: () => RootState) => {
  const { proofNotifications } = getState().proofNotifications;
  const proofNotificationsForRollBack = structuredClone(proofNotifications);
  dispatch(proofNotificationsSlice.actions.proofNotificationRemoved(id));

  try {
    await proofNotificationsService.deleteById(id);
  } catch (error) {
    dispatch(proofNotificationsSlice.actions.rollback(proofNotificationsForRollBack));
    throw error;
  }
};

export default proofNotificationsSlice.reducer;
